
import { ClipLoader } from 'react-spinners'
import axios from 'axios'
import { toast } from 'sonner'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setUserSessionData } from '../../../../lib/userSessionSlice'
import { Link } from 'react-router-dom'
import { timeAgoIso } from '../../../Raydium/utils'
import { FaWallet } from 'react-icons/fa6'
import { MdNavigateBefore } from "react-icons/md";
import { MdOutlineNavigateNext } from "react-icons/md";
import { SiSolana } from "react-icons/si";



export default function WithdrawProfits({ userData }) {
    const [isLoading, setIsloading] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 3
    const dispatch = useDispatch()
    const setUserSession = (data) => dispatch(setUserSessionData(data))


    let claimTransactions = userData?.transactions?.filter((tx) => tx.type == "withdraw")

    let walletAddress = userData?.address
    let balance = (parseFloat(userData?.referralBalance?.toFixed(2)))
    let disabled = !balance > 0 || isLoading





    const lastIndex = currentPage * itemsPerPage
    const firstIndex = lastIndex - itemsPerPage
    const transactions = claimTransactions?.slice(firstIndex, lastIndex)
    const totalPages = Math.ceil(claimTransactions?.length / itemsPerPage)

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1)
        }
    }

    const goToPrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
    }








    async function revalidateUser() {
        let baseUrl = process.env.REACT_APP_API_BASE_URL;
        let endpoint = `${baseUrl}/users/create`;
        let data = {
            address: walletAddress,
            referredBy: null,
        };

        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "authorization": process.env.REACT_APP_API_KEY
            }
        }

        try {

            let response = await axios.post(endpoint, data, config);
            setUserSession(response.data.data)
            setIsloading(false)
        } catch (error) {
            console.error("Error:", error.response?.data || error.message);
        }
    }


    async function makePayment() {
        setIsloading(true)
        toast.info('Claiming your profits Please Wait ...', { duration: 6000 })
        let baseUrl = process.env.REACT_APP_API_BASE_URL
        let endpoint = `${baseUrl}/referrals/claim`
        let data = {
            address: userData?.address
        };
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "authorization": process.env.REACT_APP_API_KEY
            }
        }
        try {

            const res = await axios.post(endpoint, data, config).then((res) => res.data)
            console.log(res)
            await revalidateUser()
        } catch (err) {

            toast.error(err.message)
            setIsloading(false)
        }
    }




    function ClaimHistory() {

        return (

            <>
                <table className="outline outline-yellow-500/10 outline-1  bg-black overflow-hidden h-max w-full">

                    <thead className=" bg-neutral-900  ">
                        <tr className="text-yellow-600 text-left font-semibold capitalize text-xs w-full ">
                            <th className="p-3 text-xxs">Address</th>
                            <th className="p-3 text-xxs">Amount </th>
                            <th className="p-3 text-xxs">TimeStamp</th>
                            <th className="p-3 text-xxs">hash</th>
                        </tr>
                    </thead>

                    <tbody className="!overflow-y-scroll w-full">
                        {
                            transactions?.map(({ address, phase, solAmount, createdAt, txHash, tokenBonus, bonus }, i) => {


                                return (
                                    <tr key={'table' + i} className="text-neutral-300  border-b border-neutral-800  hover:bg-neutral-400/10 transition-all h-14 " >
                                        <td className="p-3 text-xxs text-yellow-500 hover:text-pink-500 truncate">
                                            <Link to={`https://solscan.io/account/${address}`} target="_blank" className="flex items-center gap-2">
                                                {address?.slice(0, 5)} {userData?.address == address ? <FaWallet className="text-yellow-500" /> : "..."
                                                }
                                            </Link>
                                        </td>

                                        <td className={`p-3 text-sm font-semibold  "text-neutral-400" text-green-500  `}>{solAmount} SOL  </td>
                                        <td className="p-1 text-xxs  "> <span    className="p-1 text-xxs w-full  border border-neutral-800  rounded-lg  bg-neutral-800 ">{timeAgoIso(createdAt)}</span>   </td>
                                        <td className="p-3 text-xxs text-yellow-500 hover:text-pink-500 truncate">
                                            <Link to={`https://solscan.io/tx/${txHash}`} target="_blank" rel="noopener noreferrer">
                                    <SiSolana className="text-black bg-neutral-500 p-1 rounded-full hover:scale-110 cursor-pointer w-5 h-5" />
                                </Link>

                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>


                {userData?.transactions?.length > itemsPerPage &&
                    <div className="flex justify-start gap-2 items-center mt-4">

                        <button disabled={currentPage === 1} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToPrevPage} >
                            <MdNavigateBefore className="text-2xl text-black" />
                        </button>
                        <button disabled={currentPage === totalPages} className="bg-yellow-500 rounded-full p-1 items-center justify-center cursor-pointer hover:scale-110" onClick={goToNextPage}>
                            <MdOutlineNavigateNext className="text-2xl text-black" />
                        </button>

                        <span className="p-2 text-white text-xs">Page {currentPage} of {totalPages}</span>

                    </div>
                }


            </>

        )
    }









    return (
        <>
            <div className='w-full flex md:flex-row flex-col gap-5 '>


                <div className='w-full h-full  space-y-2    text-neutral-200    md:p-5 '>
                    <h1 className='font-bold text-xl text-orange-500'>Withdraw Referral Profits</h1>

                    <ul className="text-sm w-full text-neutral-200">

                        <li>✅ For Security Reasons The Profits can only be withdrawn to the same User Wallet</li>
                        <li>✅ Partner Gets 5% of each Buy from his Referrals including future Transactions</li>
                        <li>✅ Partner Gets additional 2% from His Referral Earnings</li>
                        <li>✅ No Minimum to withdraw ! you can withdraw instantly as long as the Balance is Positive</li>

                    </ul>

                    <p>You can claim Your Profits by Clicking the button bellow</p>
                    <button disabled={disabled} onClick={makePayment} className="py-2 disabled:bg-neutral-400 w-40 disabled:cursor-not-allowed  px-2 text-xs bg-yellow-500 hover:bg-green-500 text-black rounded flex items-center justify-center"  >{!isLoading ? balance != 0 ? `Claim ${balance} SOL` : "Claim Profits" : <ClipLoader
                        loading
                        size={20}
                    />}
                    </button>
                </div>
                {transactions?.length > 0 &&
                    <div className='w-full h-full  space-y-2    text-neutral-200    md:p-5'>
                        <h1 className='font-bold text-xl text-orange-500'>Last Profit Claims :</h1>
                        <div className='flex flex-col gap-2 w-full'>
                            <ClaimHistory transactions={transactions} />


                        </div>

                    </div>
                }
            </div>
        </>
    )
}


